//import firebase from 'firebase/app';
//import 'firebase/functions';
import parentCommonService from '@/app-template/lib/services/CommonService';

export default {
  ...parentCommonService,
}